/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_To_TopInputs */

const en_nav_to_top = /** @type {(inputs: Nav_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top`)
};

const lv_nav_to_top = /** @type {(inputs: Nav_To_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uz augšu`)
};

/**
* | output |
* | --- |
* | "Top" |
*
* @param {Nav_To_TopInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_to_top = /** @type {((inputs?: Nav_To_TopInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_To_TopInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_to_top(inputs)
	return en_nav_to_top(inputs)
});